var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
module.exports = {
  getProvince: getProvince,
  calculateNLeadsForJob: calculateNLeadsForJob,
  getFullQuery: getFullQuery
};
var Parse = require("parse");
var provinces = {
  "01": "Alava",
  "02": "Albacete",
  "03": "Alicante",
  "04": "Almeria",
  "05": "Avila",
  "06": "Badajoz",
  "07": "Islas Baleares",
  "08": "Barcelona",
  "09": "Burgos",
  "10": "Caceres",
  "11": "Cadiz",
  "12": "Castellon",
  "13": "Ciudad Real",
  "14": "Cordoba",
  "15": "La Coruña",
  "16": "Cuenca",
  "17": "Gerona",
  "18": "Granada",
  "19": "Guadalajara",
  "20": "Guipuzcoa",
  "21": "Huelva",
  "22": "Huesca",
  "23": "Jaen",
  "24": "Leon",
  "25": "Lerida",
  "26": "La Rioja",
  "27": "Lugo",
  "28": "Madrid",
  "29": "Malaga",
  "30": "Murcia",
  "31": "Navarra",
  "32": "Orense",
  "33": "Asturias",
  "34": "Palencia",
  "35": "Las Palmas",
  "36": "Pontevedra",
  "37": "Salamanca",
  "38": "Santa Cruz de Tenerife",
  "39": "Cantabria",
  "40": "Segovia",
  "41": "Sevilla",
  "42": "Soria",
  "43": "Tarragona",
  "44": "Teruel",
  "45": "Toledo",
  "46": "Valencia",
  "47": "Valladolid",
  "48": "Vizcaya",
  "49": "Zamora",
  "50": "Zaragoza",
  "51": "Ceuta",
  "52": "Melilla"
};
function getProvince(postalCode) {
  if (postalCode && postalCode.length === 5) return provinces[postalCode.substring(0, 2)];else return "Otro";
}
function calculateNLeadsForJob(job, subvertical) {
  var vertical = subvertical ? subvertical : job.has("Subvertical") ? job.get("Subvertical") : job.get("Vertical");
  var nLeads = vertical.get("nLeads");
  var jobPrice;
  if (job.has("PostalCode")) {
    var pcString = "PC" + job.get("PostalCode").substring(0, 2);
    jobPrice = vertical.has(pcString) ? vertical.get(pcString) : nLeads;
  } else jobPrice = nLeads;
  return jobPrice > 1 ? jobPrice - 1 : 1;
}
/**
 *
 * @method getJobsQuery
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Array} provinces
 * @param {Array} services
 * @param {Array} levels
 * @param {Array} slots
 * @param {Array} jobStates
 * @param {Array} businesses
 * @returns {Parse.Query} Query
 */

function getJobsQuery(startDate, endDate, provinces, services, levels, slots, jobStates, businesses, agents) {
  var Verticales = Parse.Object.extend("Verticales");
  var Business = Parse.Object.extend("Business");
  var CRMUser = Parse.Object.extend("CRMUser");
  var query = new Parse.Query("Jobs");
  if (agents && agents.length > 0) {
    var unassigned = agents.filter(function (agent) {
      return !agent || !agent.id;
    });
    var agentPointers = agents.filter(function (agent) {
      return agent && agent.id;
    }).map(function (agent) {
      return CRMUser.createWithoutData(agent.id);
    });
    if (agentPointers.length > 0 && unassigned.length > 0) {
      var q1 = new Parse.Query("Jobs").doesNotExist("AssignedTo");
      var q2 = new Parse.Query("Jobs").containedIn("AssignedTo", agentPointers);
      query = Parse.Query.or(q1, q2);
    } else if (agentPointers.length > 0) {
      query.containedIn("AssignedTo", agentPointers);
    } else if (unassigned.length > 0) {
      query.doesNotExist("AssignedTo");
    }
  } // on filters that are no suppose to exist on transportation jobs, check

  if (levels && levels.length > 0) query.containedIn("Level", levels.map(function (level) {
    return Number(level);
  }));
  if (slots && slots.length > 0) query.containedIn("nJober", slots.map(function (slot) {
    return Number(slot);
  }));
  if (services && services.length > 0) query.containedIn("Vertical", services.map(function (service) {
    return Verticales.createWithoutData(service.id);
  }));
  if (jobStates && jobStates.length > 0) {
    query.containedIn("State", jobStates);
  }
  if (provinces && provinces.length > 0) {
    query.matches("PostalCode", new RegExp("^(".concat(provinces.join("|"), ")")));
  }
  if (businesses && businesses.length > 0) query.containedIn("Business", businesses.map(function (business) {
    return Business.createWithoutData(business.id);
  }));
  if (startDate) query.greaterThan("createdAt", new Date(startDate));
  if (endDate) query.lessThanOrEqualTo("createdAt", new Date(endDate));
  return query;
}
/**
 *
 * @method getTransportQuery
 * @param {Integer} limit
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Array} stores
 * @param {Array} orders
 * @param {boolean} creationDate
 * @param {boolean} deliveryDate
 * @returns {Parse.Query} Query
 */

function getTransportQuery(limit, startDate, endDate, stores, orders, creationDate, deliveryDate) {
  var Verticales = Parse.Object.extend("Verticales");
  var queryTransport;
  if (creationDate && startDate && endDate) {
    queryTransport = new Parse.Query("Transportation").greaterThan("createdAt", new Date(startDate)).lessThanOrEqualTo("createdAt", new Date(endDate));
  } else if (deliveryDate && startDate && endDate) {
    var q1 = new Parse.Query("Transportation").greaterThan("DeliveryDate", new Date(startDate)).lessThanOrEqualTo("DeliveryDate", new Date(endDate));
    var q2 = new Parse.Query("Transportation").doesNotExist("DeliveryDate");
    queryTransport = Parse.Query.or(q1, q2).notEqualTo("State", "cancelled");
  } else {
    queryTransport = new Parse.Query("Transportation");
  }
  if (stores && stores.length > 0) queryTransport.containedIn("Vertical", stores.map(function (store) {
    return Verticales.createWithoutData(store.id);
  }));
  if (orders && orders.length > 0) queryTransport.containedIn("State", orders);
  if (limit !== "none") queryTransport.limit(!isNaN(limit) ? limit : 50);
  queryTransport.descending("createdAt");
  return queryTransport;
}
/*
 * Contains functions for calling and declaring
 *
 * @class Jobin.Job
 * @static
 * @hideconstructor
 */

/**
 * @method getFullQuery
 * @param {ParseObject} user
 * @param {Integer} limit
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Array} provinces
 * @param {Array} services
 * @param {Array} levels
 * @param {Array} slots
 * @param {Array} jobState
 * @param {string} id
 * @param {Array} stores
 * @param {Array} orders
 * @param {boolean} creationDate
 * @param {boolean} deliveryDate
 * @param {Array} businesses
 * @returns {Parse.Query} Query
 */
function getFullQuery(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
  return _getFullQuery.apply(this, arguments);
}
function _getFullQuery() {
  _getFullQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(user, limit, startDate, endDate, provinces, services, levels, slots, jobStates) {
    var id,
      stores,
      orders,
      creationDate,
      deliveryDate,
      businesses,
      agents,
      finalQuery,
      _query,
      notiQuery,
      notiArray,
      tempArray,
      _query2,
      _notiQuery,
      _notiArray,
      _tempArray,
      jobPointers,
      tempQuery,
      _query3,
      _notiQuery2,
      _notiArray2,
      _tempArray2,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _args.length > 9 && _args[9] !== undefined ? _args[9] : "";
          stores = _args.length > 10 ? _args[10] : undefined;
          orders = _args.length > 11 ? _args[11] : undefined;
          creationDate = _args.length > 12 ? _args[12] : undefined;
          deliveryDate = _args.length > 13 ? _args[13] : undefined;
          businesses = _args.length > 14 ? _args[14] : undefined;
          agents = _args.length > 15 ? _args[15] : undefined;
          if (!id.match(/^PC-\d/)) {
            _context.next = 11;
            break;
          }
          finalQuery = new Parse.Query("FixedInfo").startsWith("ID", id);
          _context.next = 94;
          break;
        case 11:
          if (!id.match(/^TR-\d/)) {
            _context.next = 18;
            break;
          }
          finalQuery = new Parse.Query("Transportation");
          finalQuery.startsWith("ID", id);
          if (limit !== "none") finalQuery.limit(!isNaN(limit) ? limit : 50);
          finalQuery.descending("createdAt");
          _context.next = 94;
          break;
        case 18:
          if (!(id === "TR-")) {
            _context.next = 37;
            break;
          }
          finalQuery = getTransportQuery(limit, startDate, endDate, stores, orders, creationDate, deliveryDate);
          if (!user) {
            _context.next = 35;
            break;
          }
          if (!user.get("Jober")) {
            _context.next = 34;
            break;
          }
          _query = getJobsQuery(startDate, endDate, provinces, services, levels, slots, jobStates, businesses, agents);
          notiQuery = new Parse.Query("Notifications");
          notiQuery.equalTo("FromUser", user);
          notiQuery.equalTo("Type", "aceptoT");
          notiQuery.matchesQuery("Jobs", _query);
          _context.next = 29;
          return notiQuery.find();
        case 29:
          notiArray = _context.sent;
          tempArray = notiArray.map(function (item) {
            return item.get("Jobs").id;
          });
          finalQuery.containedIn("Job", tempArray);
          _context.next = 35;
          break;
        case 34:
          query.equalTo("CreatedBy", user);
        case 35:
          _context.next = 94;
          break;
        case 37:
          if (!(id === "PC-")) {
            _context.next = 73;
            break;
          }
          // checks if we are trying to filter by FixedInfo Job
          _query2 = getJobsQuery(startDate, endDate, provinces, services, levels, slots, jobStates, businesses, agents); //Download the Jobs query
          _query2.equalTo("JobType", "fixed");
          if (limit !== "none") _query2.limit(!isNaN(limit) ? limit : 50);
          _query2.descending("createdAt");
          _query2.select(["objectId"]);
          if (!user) {
            _context.next = 57;
            break;
          }
          if (!user.get("Jober")) {
            _context.next = 56;
            break;
          }
          _notiQuery = new Parse.Query("Notifications");
          _notiQuery.equalTo("FromUser", user);
          _notiQuery.equalTo("Type", "aceptoT");
          _notiQuery.matchesQuery("Jobs", _query2);
          _context.next = 51;
          return _notiQuery.find();
        case 51:
          _notiArray = _context.sent;
          _tempArray = _notiArray.map(function (item) {
            return item.get("Jobs").id;
          });
          _query2.containedIn("objectId", _tempArray);
          _context.next = 57;
          break;
        case 56:
          _query2.equalTo("CreatedBy", user);
        case 57:
          _context.prev = 57;
          _context.next = 60;
          return _query2.find();
        case 60:
          jobPointers = _context.sent;
          tempQuery = new Parse.Query("FixedInfo");
          tempQuery.containedIn("Job", jobPointers);
          if (limit !== "none") tempQuery.limit(!isNaN(limit) ? limit : 50);
          finalQuery = tempQuery;
          _context.next = 71;
          break;
        case 67:
          _context.prev = 67;
          _context.t0 = _context["catch"](57);
          console.error(_context.t0);
          return _context.abrupt("return", {
            status: "error",
            result: "Fallo en query getJobs()"
          });
        case 71:
          _context.next = 94;
          break;
        case 73:
          _query3 = getJobsQuery(startDate, endDate, provinces, services, levels, slots, jobStates, businesses, agents); // or a regular Job (lead)
          _query3.equalTo("JobType", "lead");
          _query3.include(['Incidence']);
          if (id) _query3.startsWith("objectId", id);
          if (limit !== "none") _query3.limit(!isNaN(limit) ? limit : 100);
          _query3.descending("createdAt"); //Filter by user if needed
          if (!user) {
            _context.next = 93;
            break;
          }
          if (!user.get("Jober")) {
            _context.next = 92;
            break;
          }
          _notiQuery2 = new Parse.Query("Notifications");
          _notiQuery2.equalTo("FromUser", user);
          _notiQuery2.equalTo("Type", "aceptoT");
          _notiQuery2.matchesQuery("Jobs", _query3);
          _context.next = 87;
          return _notiQuery2.find();
        case 87:
          _notiArray2 = _context.sent;
          _tempArray2 = _notiArray2.map(function (item) {
            return item.get("Jobs").id;
          });
          _query3.containedIn("objectId", _tempArray2);
          _context.next = 93;
          break;
        case 92:
          _query3.equalTo("CreatedBy", user);
        case 93:
          finalQuery = _query3;
        case 94:
          return _context.abrupt("return", finalQuery);
        case 95:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[57, 67]]);
  }));
  return _getFullQuery.apply(this, arguments);
}